// extracted by mini-css-extract-plugin
module.exports = {"swatch":"InlineColorPicker_swatch__11WDP","color":"InlineColorPicker_color__12j-E","popover":"InlineColorPicker_popover__3Hchl","cover":"InlineColorPicker_cover__2KTIs"};